<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     编辑商品
  +---------------------------------------------------------------------------------------
-->

<template>
  <el-dialog
    class="product-edit"
    width="600px"
    :title="product.productid ? '编辑商品' : '新建商品'"
    :visible.sync="dialogShow"
    :modal-append-to-body="false"
    :close-on-click-modal="false">
    <el-form v-loading="posting" ref="productForm" :model="newProduct" :rules="rules" label-position="left" label-width="100px" style="padding: 0 40px 30px;">
      <el-form-item label="商品图" prop="thumb_url">
        <f-image-card-uploader :files="picture" :limit="1" aimPath="oioc/product/" @change="imageUpload" />
      </el-form-item>
      <el-form-item label="品牌" prop="brand">
        <el-input v-model="newProduct.brand" autocomplete="off" />
      </el-form-item>
      <el-form-item label="名称" prop="name">
        <el-input v-model="newProduct.name" autocomplete="off" />
      </el-form-item>
      <el-form-item label="型号" prop="model">
        <el-input v-model="newProduct.model" autocomplete="off" />
      </el-form-item>
      <el-form-item label="支持核销">
        <div class="flex align-items-center" style="width: 100%;">
          <el-switch v-model="newProduct.verify_enable" :active-value="1" :inactive-value="0" class="bd" />
          <el-button type="text" class="ft" @click="openDoc">如何使用核销功能？</el-button>
        </div>
      </el-form-item>
      <el-form-item v-if="newProduct.verify_enable" prop="verify_value">
        <span slot="label" class="flex align-items-center">
          <el-tooltip effect="dark" content="扫码核销时，系统会将此标识作为核验参数的设定值下发给设备；标识应为数字" placement="top">
            <span role="button">标识<i class="el-icon-info text-light ml-xs"></i></span>
          </el-tooltip>
        </span>
        <el-input v-model="newProduct.verify_value" autocomplete="off" />
      </el-form-item>
    </el-form>

    <div slot="footer" class="flex-center mb">
      <el-button class="extend" @click="dialogShow = false">取消</el-button>
      <el-button class="extend" type="primary" :loading="posting" @click="submit">确认</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { productPostApi } from "@/api/fam/famCodeApi";
import { validateNumber } from "@/utils/validate";

export default {
  name: 'ProductEdit',

  components: {
    FImageCardUploader: () => import("@/components/FImageCardUploader"),
  },

  props: {
    show: {
      type: Boolean,
      default: false
    },

    product: {
      type: Object,
      default: () => {
        return {};
      }
    },
  },

  data() {
    var validateNo = (rule, value, callback) => {
      value = +value
      if (!value) {
        callback(new Error('标识应为数字'))
      } else {
        if (validateNumber(value)) {
          callback()
        } else {
          return callback(new Error('标识应为数字'))
        }
      }
    }

    return {
      newProduct: {
        thumb_url: '',
        brand: '',
        name: '',
        model: '',
        verify_enable: 1,
        verify_value: 1
      },

      rules: {
        thumb_url: [{ required: true, message: '商品图不能为空', trigger: 'blur' }],
        brand: [{ required: true, message: '品牌不能为空', trigger: 'blur' }],
        name: [{ required: true, message: '名称不能为空', trigger: 'blur' }],
        model: [{ required: true, message: '型号不能为空', trigger: 'blur' }],
        verify_value: [
          { required: true, message: "标识不能为空", trigger: "blur" },
          { validator: validateNo, trigger: "blur" }
        ],
      },

      posting: false
    }
  },

  computed: {
    dialogShow: {
      get() {
        return this.show
      },
      set(val) {
        this.$emit('update:show', val)
      }
    },

    picture() {
      const arr = []
      if (!this.newProduct.thumb_url) {
        return []
      }
      arr.push({
        url: this.newProduct.thumb_url
      })
      return arr
    },
  },

  created() {
    if (this.product.productid) this.newProduct = Object.assign({}, this.newProduct, this.product)
  },

  methods: {
    openDoc() {
      window.open('https://wiki.frippler.com/#/docs/fs/fcs/161')
    },

    imageUpload(arr) {
      this.newProduct.thumb_url = arr.length === 0 ? '' : arr[0].url
      this.$nextTick(() => {
        this.$refs['productForm'].clearValidate()
      })
    },

    submit() {
      this.$refs['productForm'].validate((valid) => {
        if (valid) {
          this.posting = true
          productPostApi(this.newProduct).then(res => {
            if (!res.errno) {
              // 操作成功处理
              this.$message.success(this.newProduct.productid ? '编辑成功！' : '新建成功')
              this.$emit('success')
              this.dialogShow = false
            } else {
              this.$message.error(res.message)
            }
          }).catch((err) => {
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
/deep/ .el-form-item--medium .el-form-item__label {
  display: flex;
}
.product-edit {
}
</style>
